module.exports = __webpack_public_path__ + "static/media/the-harbour-inn.6bd4dcff.jpg";